import { useCallback } from 'react';
import { RankingService } from '../ranking/rankingService';
import { UserService } from '../user/userService';

/**
 * Hook personalizado para manejar operaciones relacionadas con rankings
 * Proporciona métodos para obtener rankings y clasificaciones
 */
export const useRankingsService = () => {
    const rankingService = new RankingService();
    const userService = new UserService();

    /**
     * Obtiene todos los rankings disponibles
     * @param filters - Filtros opcionales para la búsqueda
     * @returns Promise con la lista de rankings
     */
    const getAllRankings = useCallback(async (filters?: any) => {
        const response = await rankingService.listAllRankings(filters);
        return response.getResponseData();
    }, []);

    /**
     * Obtiene la clasificación de un ranking específico
     * @param rankingId - ID del ranking
     * @returns Promise con la clasificación del ranking
     */
    const getRankingClassification = useCallback(async (rankingId: string) => {
        const response = await userService.showRankingClassification(rankingId);
        return response.getResponseData();
    }, []);

    /**
     * Obtiene los detalles de un ranking específico
     * @param rankingId - ID del ranking
     * @returns Promise con los detalles del ranking
     */
    const getRankingDetails = useCallback(async (rankingId: string) => {
        const response = await rankingService.getRankingById(rankingId);
        return response.getResponseData();
    }, []);

    return {
        getAllRankings,
        getRankingClassification,
        getRankingDetails
    };
};